import { Chip, Tooltip } from '@material-ui/core';
import Icon from '@mdi/react';
import { mdiCreation } from '@mdi/js';
import React from 'react';
import { useTranslation } from 'react-i18next';

// A tag link the AI tagger applied carries `source: 'AI'`; a link a person
// added has no `source` at all (the API never lets a client set it).
export const isAiTag = (tag) => tag.source === 'AI';

export const MediaTagChip = ({ tag, onDelete }) => {
  const { t } = useTranslation();

  return (
    // An empty title renders no tooltip, so user-added tags stay as before.
    <Tooltip title={isAiTag(tag) ? t('gallery.ai_tag') : ''}>
      <Chip
        color="primary"
        icon={
          isAiTag(tag) ? <Icon path={mdiCreation} size={0.7} /> : undefined
        }
        label={`${tag.assignmentNumberPath ? tag.assignmentNumberPath : ''} ${
          tag.name
        }`}
        onDelete={onDelete}
        // Never shrink: the strip decides how many chips fit from their
        // natural widths, so a squeezed chip would break that arithmetic.
        style={{ opacity: 0.9, fontSize: '14px', flexShrink: 0 }}
      ></Chip>
    </Tooltip>
  );
};
